import React, { useState, useEffect, Fragment } from 'react';
import Gallery from 'react-photo-gallery';
import {
  Card,
  CardBody,
  Button,
  ButtonGroup,
  Form,
  CustomInput,
  FormGroup,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  Row,
  CardImg,
} from 'reactstrap';
import {
  Colxx,
  Separator,
} from '../../../../../../components/common/CustomBootstrap';
import {
  gAPI_Call_Flows,
  gAPI_QuestionSets,
} from '../../../../../../constants/APIs';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import ImageGallery from '../../../propinfo/gallery/index';
import Switch from 'rc-switch';
import 'rc-switch/assets/index.css';
let arr = [];
export default function ConfigurationBehavior({
  integration,
  integrationProperties,
  allProperties,
  locale,
  saveIntegration,
}) {
  const [callFlow, setCallFLowList] = useState([]);
  const [galleryVisible, setGalleryVisible] = useState(false);
  const [configurationSettings, setConfigurationSettings] = useState({
    welcomeMessage: '',
    interruptable: false,
    isDynamicConversationFlow: false,
    assistantId: '',
    humanAssistant: false,
    e64Format: '',
    speechToText: '',
    replaces: '',
    keywords: '',
    ...integration?.phoneSuiteIntegration?.configurationSettings,
  });
  const [assistantList, setAssistantList] = useState([]);
  const [selectedProperty, setSelectedProperty] = useState(
    integrationProperties.length > 0 ? integrationProperties[0] : ''
  );

  const [isEditing, setIsEditing] = useState(false);
  const [list, setList] = useState([]);
  const [name, setName] = useState('');
  const [propertyList, setPropertyList] = useState([]);
  useEffect(() => {
    const result = integrationProperties.map((id) => {
      return allProperties.find((elem) => elem.id === id);
    });
    setList(integrationProperties);
    if (integration.name !== undefined && integration.name !== null) {
      setName(integration.name);
    }
    const property = allProperties.map((elem) => {
      elem.checked = false;
      result.forEach((lang) => {
        if (lang.id === elem.id) {
          elem.checked = true;
        }
      });
      return elem;
    });
    setPropertyList(property);

    AxiosAPI({
      method: 'get',
      url: `${gAPI_Call_Flows}`,
    }).then((res) => {
      setCallFLowList(res.data);
    });
  }, [integrationProperties, allProperties]);

  const selectedImage = (image) => {
    setConfigurationSettings({
      ...configurationSettings,
      serviceProviderLogo: image.src,
    });
  };

  const handleChangeAssistantId = (e) => {
    setConfigurationSettings({
      ...configurationSettings,
      assistantId: e.target.value,
    });
  };

  const togglegallery = () => {
    setGalleryVisible(!galleryVisible);
  };

  useEffect(() => {
    if (selectedProperty) {
      loadResponse();
    }
  }, [selectedProperty]);

  const loadResponse = async () => {
    return await AxiosAPI({
      methed: 'get',
      url: `${gAPI_QuestionSets}/?propertyId=${selectedProperty}&groupId=${getGroupID()}&lang=${locale}`,
    })
      .then((res) => {
        var setslist = res.data.sets.sort(
          (a, b) => a.displayOrder - b.displayOrder
        );
        var list = [];
        if (setslist !== null && setslist.length > 0) {
          setslist
            .filter(
              (l) =>
                l.type === 'DynamicConversationFlow' &&
                l.openAiAssistantId !== ''
            )
            .map((l) => {
              list.push({ id: l.openAiAssistantId, name: l.name });
            });
        }

        setAssistantList(list);
      })
      .catch((err) => {
        console.error(
          'API error:',
          err.response ? err.response.data : err.message
        );
      });
  };

  const ImageGalleryButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal
                isOpen={galleryVisible}
                toggle={togglegallery}
                style={{ maxWidth: '1000px' }}
              >
                <ModalHeader toggle={togglegallery}>Select Avatar</ModalHeader>
                <ModalBody>
                  <ImageGallery
                    selectedImage={selectedImage}
                    togglegallery={togglegallery}
                    hideUserUploads={false}
                    searchText={'avatar'}
                  />
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  const handleCheckChange = (e) => {
    // if (e.target.checked) {
    //   arr[e.target.id] = e.target.value;
    // }
    // if (!e.target.checked) {
    //   arr[e.target.id] = undefined;
    // }
    // const filterList = arr.filter(elem => elem !== undefined || null);
    // setList(filterList);

    const values = propertyList.map((elem) => {
      if (elem.id === e.target.value) {
        elem.checked = !elem.checked;
      }
      return {
        ...elem,
      };
    });
    const propertyArr = values
      .filter((elem) => elem.checked === true)
      .map((elem) => elem.id);
    setList(propertyArr);
  };

  const handleSave = () => {
    saveIntegration({ configurationSettings: configurationSettings });
    arr = [];
    setList([]);
  };

  const handleConfigurationChange = (e) => {
    setConfigurationSettings({
      ...configurationSettings,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangeWelcomeMessage = (e) => {
    setConfigurationSettings({
      ...configurationSettings,
      welcomeMessage: e.target.value,
    });
  };

  const handleWaitingSeconds = (e) => {
    setConfigurationSettings({
      ...configurationSettings,
      waitingSeconds: e.target.value,
    });
  };
  const handleChangeInternalWelcomeMessage = (e) => {
    setConfigurationSettings({
      ...configurationSettings,
      internalWelcomeMessage: e.target.value,
    });
  };

  const handleChangeGenerativeInstructions = (e) => {
    setConfigurationSettings({
      ...configurationSettings,
      gptInstructions: e.target.value,
    });
  };

  const handleOpenAiModal = (e) => {
    setConfigurationSettings({
      ...configurationSettings,
      openAIModal: e.target.value,
    });
  };

  const handleActivateAiFlows = (val) => {
    let callFlow = configurationSettings.activeCallFlows;
    if (callFlow.filter((f) => f === val).length > 0) {
      callFlow = callFlow.filter((f) => f !== val);
    } else {
      callFlow.push(val);
    }
    setConfigurationSettings({
      ...configurationSettings,
      activeCallFlows: callFlow,
    });
  };

  const handleCheckedGenerativeGTP3 = (e) => {
    setConfigurationSettings({
      ...configurationSettings,
      isGenAI: e,
      isDynamicConversationFlow: false,
    });
  };

  const handleHumanAsistant = (e) => {
    setConfigurationSettings({
      ...configurationSettings,
      humanAssistant: e,
    });
  };

  const handleES6Format = (e) => {
    setConfigurationSettings({
      ...configurationSettings,
      e64Format: e.target.value,
    });
  };

  const handleCheckedOpenAIEnabled = (e) => {
    setConfigurationSettings({
      ...configurationSettings,
      isDynamicConversationFlow: e,
      isGenAI: false,
    });
  };

  const Edit = () => {
    return (
      <CardBody>
        <div className="text-center">
          <h6>Configure Conversational Behavior</h6>
        </div>

        <Separator className="mb-3"></Separator>

        <div className="text-left">
          <div className="mb-3">
            <h5>Welcome message</h5>
            <p className="my-2">
              The first message the agent will say.
            </p>
            <Input
              className="form-control"
              name="welcomeMessage"
              type="textarea"
              defaultValue={configurationSettings.welcomeMessage}
              placeholder="Welcome, how can I help you today?"
              onChange={handleChangeWelcomeMessage}
            />
            <div className="mt-3">
              <Label>
                <b>Interruptable</b>
              </Label>
              <p className="my-2">
                Allow users to interrupt the agent while the first message is being delivered.
              </p>
              <div className="">
                <Switch
                  className="agentswitch custom-switch-primary custom-switch-small"
                  checked={configurationSettings.interruptable || false}
                  name="interruptable"
                  onChange={(e) =>
                    setConfigurationSettings({
                      ...configurationSettings,
                      interruptable: e,
                    })
                  }
                />
              </div>
            </div>
          </div>
          <Separator className="my-2"></Separator>
          <div className="">
            <h5>Conversation Flow</h5>
            <p className=" my-2">
              Conversation flows are useful to provide more detailed,
              step-by-step instructions to guide a customer through a process or
              task until completion.
            </p>
            {assistantList && assistantList !== null && (
              <Fragment>
                <div className="mb-1 ml-2 ">
                  {assistantList.length > 0 ? (
                    <Input
                      className="border p-2 mb-3"
                      type="select"
                      name="assistantId"
                      placeholder="Dynamic Conversation Flow"
                      value={configurationSettings.assistantId}
                      onChange={handleChangeAssistantId}
                    >
                      <option value="">
                        Select a Dynamic Conversation Flow
                      </option>
                      {assistantList.map((assist, index) => (
                        <option key={index} value={assist.id}>
                          {`${assist.name} (${assist.id})`}
                        </option>
                      ))}
                    </Input>
                  ) : (
                    <Input
                      className="border p-2 mb-3"
                      type="text"
                      name="assistantId"
                      onChange={handleChangeAssistantId}
                      placeholder="Dynamic Conversation Flow"
                      defaultValue={configurationSettings.assistantId}
                    />
                  )}
                </div>
              </Fragment>
            )}

            <div className="d-flex align-items-center  mb-2 mt-2">
              <Button
                size="xs"
                color="primary"
                outline
                className="ml-2"
                onClick={() =>
                  window.open('/app/pages/propinfo/recommender', '_blank')
                }
              >
                Create Conversation Flow
              </Button>
              <Button
                size="xs"
                color="secondary"
                outline
                className="ml-2"
                onClick={() =>
                  window.open('/app/pages/propinfo/recommender', '_blank')
                }
              >
                View Conversation Flow
              </Button>
            </div>
          </div>
          {/* <Separator className="my-2"></Separator> */}
          <div className="ml-2 mb-3" style={{ display: 'none' }}>
            <div className="d-flex ml-2 mt-2">
              <h7 style={{ marginTop: '0.15rem' }}>
                Human assistance needed or requested
              </h7>
              <Switch
                className="agentswitch  custom-switch-primary custom-switch-small ml-2"
                checked={configurationSettings?.humanAssistant}
                name="humanAssistant"
                onChange={(e) => handleHumanAsistant(e)}
              />
            </div>
            {configurationSettings.humanAssistant === true && (
              <div className="mb-3">
                <p className="my-2">
                  Add a number in ES6 Format, which will be used to transfer the
                  AI call to in case of customer request of determined by the AI
                  voice
                </p>
                <Input
                  className="form-control"
                  name="e64Format"
                  type="text"
                  placeholder=""
                  defaultValue={configurationSettings.e64Format}
                  onChange={(e) => handleES6Format(e)}
                />
              </div>
            )}
          </div>
          <Separator className="my-2"></Separator>
          <div className="mb-3">
            <h5>Custom Vocabulary to improve speech recognition</h5>
            {/* <p className="my-2">
              Find and Replace searches for terms or phrases in speech and
              replaces them.
            </p> */}
            <p className="my-2">
              Use Keywords to boost or suppress terminology specific to your
              business.
            </p>
          </div>
          <div className="ml-2 mb-3" style={{ display: 'none' }}>
            <h6>Speech to Text Language</h6>
            <Input
              className="form-control"
              type="select"
              defaultValue={configurationSettings?.speechToText}
              name="speechToText"
              onChange={handleConfigurationChange}
            >
              <option value={''}>Please Select</option>
              <option value={'en'}>en</option>
              <option value={'en-US'}>en-US</option>
              <option value={'en-NZ'}>en-NZ</option>
              <option value={'en-IN'}>en-IN</option>
              <option value={'en-AU'}>en-AU</option>
            </Input>
          </div>
          <div className="ml-2 mb-3" style={{ display: 'none' }}>
            <h6>Find and Replace</h6>
            <Input
              className="form-control"
              type="textarea"
              placeholder="monika:Monica&hailee:hailey"
              defaultValue={configurationSettings?.replaces}
              name="replaces"
              onChange={handleConfigurationChange}
            ></Input>
          </div>
          <div className="mb-3">
            <h6>Keywords</h6>
            <Input
              className="form-control"
              type="textarea"
              placeholder="snuffleupagus:5&Rotorua:3"
              defaultValue={configurationSettings?.keywords}
              name="keywords"
              onChange={handleConfigurationChange}
            ></Input>
          </div>
          <Separator className="my-2"></Separator>
          <div className="mb-2" style={{ display: 'none' }}>
            <h5>Activate AI Call Flows</h5>
            <p className="my-2">
              Choose from a library of pre-build voice AI call flows. Each call
              flow might need its own settings based on the functionality.
            </p>

            {callFlow !== undefined &&
              callFlow.length > 0 &&
              callFlow.map((m) => (
                <CustomInput
                  key="welcomeMessageFirst"
                  type="checkbox"
                  checked={
                    configurationSettings.activeCallFlows.filter(
                      (f) => f === m.code
                    ).length > 0
                      ? true
                      : false
                  }
                  onChange={(e) => handleActivateAiFlows(m.code)}
                >
                  <span>{m.name}</span>
                </CustomInput>
              ))}
          </div>
          <div className="mt-4">
            <Label>
              <b>Eagerness</b>
            </Label>
            <p className="my-1">
              Controls how eager the agent is to respond. High eagerness means
              the agent responds quickly, while low eagerness means the agent
              waits longer to ensure the user has finished speaking.
            </p>
            <Input
              type="select"
              name="eagerness"
              className="form-control"
              value={configurationSettings.eagerness || 'Normal'}
              onChange={(e) =>
                setConfigurationSettings({
                  ...configurationSettings,
                  eagerness: e.target.value,
                })
              }
            >
              <option value="normal">Normal</option>
              <option value="patient">Patient</option>
              <option value="eager">High</option>
            </Input>
          </div>
          <div className="mt-4">
            <Label>
              <b>Spelling patience</b>
            </Label>
            <p className="my-1">
              Controls if the agent should be more patient when user is spelling
              numbers and named entities.
            </p>
            <Input
              type="select"
              name="spellingPatience"
              className="form-control"
              value={configurationSettings.spellingPatience || 'Auto'}
              onChange={(e) =>
                setConfigurationSettings({
                  ...configurationSettings,
                  spellingPatience: e.target.value,
                })
              }
            >
              <option value="auto">Auto</option>
              <option value="off">Off</option>
            </Input>
          </div>
          <div className="mt-4">
            <Label>
              <b>Speculative turn</b>
            </Label>
            <p className="my-1">
              When enabled, starts generating responses during silence before
              full turn confidence is reached, reducing perceived latency.
            </p>
            <Switch
              className="agentswitch custom-switch-primary custom-switch-small"
              checked={configurationSettings.speculativeTurn || false}
              name="speculativeTurn"
              onChange={(e) =>
                setConfigurationSettings({
                  ...configurationSettings,
                  speculativeTurn: e,
                })
              }
            />
          </div>
          <div className="mt-4">
            <Label>
              <b>Take turn after silence</b>
            </Label>
            <p className="my-1">
              The maximum number of seconds since the user last spoke. If
              exceeded, the agent will respond and force a turn. A value of -1
              means the agent will wait indefinitely for user input.
            </p>
            <div style={{ position: 'relative', width: '70%' }}>
              <Input
                type="number"
                name="takeTurnAfterSilence"
                className="form-control"
                min={10}
                value={
                  configurationSettings.takeTurnAfterSilence !== undefined
                    ? configurationSettings.takeTurnAfterSilence
                    : 10
                }
                onChange={(e) =>
                  setConfigurationSettings({
                    ...configurationSettings,
                    takeTurnAfterSilence: e.target.value,
                  })
                }
                step={1}
                style={{ paddingRight: '70px' }}
              />
              <span
                style={{
                  position: 'absolute',
                  right: '10px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  pointerEvents: 'none',
                  color: '#6c757d',
                  fontSize: '14px',
                }}
              >
                Seconds
              </span>
            </div>
          </div>
        </div>
        <div className="text-center">
          <div className="mb-2 text-center" style={{ marginTop: '20px' }}>
            <Button color="primary" size="xs" onClick={handleSave}>
              Save
            </Button>
            <Button
              size="xs"
              color="secondary"
              className="ml-2"
              onClick={() => setIsEditing(!isEditing)}
            >
              Cancel
            </Button>
          </div>
        </div>
        {ImageGalleryButton()}
      </CardBody>
    );
  };

  return <Card className="mb-4"> {Edit()}</Card>;
}
